import React from 'react';
import classnames from 'classnames';
import styles from './Section.scss';

const Section = ({ children, className }) => (
	<div className={classnames(className, 'h-100', styles.root)}>{children}</div>
);

Section.Heading = ({ children }) => <h2 className={styles.heading}>{children}</h2>;

Section.SubHeading = ({ children }) => <h3 className={styles.subHeading}>{children}</h3>;

export default Section;



// WEBPACK FOOTER //
// ./src/ui/components/Section.js